import React from 'react'
import { X } from 'lucide-react'
import { useLocation, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { translations, allPaths } from '../../utils/constants'
import { TbLogout2 } from 'react-icons/tb'
import { FaUserAlt } from 'react-icons/fa'
import { handleLogout } from '../../utils/helpers'
import { Tooltip } from 'antd'
import { elmecLogo } from '../../assets'
import { getMenuGroups, isMenuItemActive } from './menuConfig'

const MobileMenu = ({ isOpen, onClose }) => {
    const location = useLocation()
    const history = useHistory()
    const dispatch = useDispatch()
    const language = useSelector((state) => state.languageReducer?.language)
    const user = useSelector(state => state?.authReducer?.user)
    const organizationDetails = useSelector(state => state?.authReducer?.organization)

    if (!isOpen) return null

    const handleLogoutButton = () => {
        handleLogout(history, dispatch);
        history.push(allPaths?.LOGIN);
    }

    const menuGroups = getMenuGroups({ language, user })

    const truncateText = (text, maxLength) => {
        if (text?.length > maxLength) {
            return text.substring(0, maxLength) + '...'
        }
        return text
    }

    return (
        <>
            <div className="mobile-overlay" onClick={onClose}></div>

            <div className="mobile-menu">
                <div className="mobile-menu-header">
                    <div className='logo-container'>
                        <div className='logo-main-div'>
                            <img src={organizationDetails?.logo || elmecLogo} alt='Default Logo' className='sidelogo' />
                        </div>
                    </div>
                    <button className="close-button" onClick={onClose}>
                        <X size={24} />
                    </button>
                </div>
                <div
                    className="user-info user-info-link"
                    role="button"
                    onClick={() => {
                        history.push(allPaths?.SETTINGS)
                        onClose()
                    }}
                >
                    <div className="user-logo">
                        <Tooltip title={user?.email} placement="bottomRight">
                            {user?.profileImage ? (
                                <img src={user.profileImage} alt={user?.username || 'user'} className="user-logo-img" />
                            ) : (
                                user?.username ? user?.username.charAt(0).toUpperCase() : "U"
                            )}
                        </Tooltip>
                    </div>
                    <Tooltip title={user?.email} placement="bottom">
                        <div className="user-details">
                            <p className="user-name capitalized-name truncate-text">
                                {truncateText(user?.username, 20)}
                            </p>
                            <p className="user-email truncate-text">
                                {truncateText(user?.email, 20)}
                            </p>
                        </div>
                    </Tooltip>
                </div>
                <nav className="mobile-menu-nav">
                    {menuGroups.map((group) => (
                        <div className='menu-group' key={group.key}>
                            <div className='menu-group-label'>
                                <span className='menu-group-label-text'>{group.label}</span>
                            </div>
                            {group.items.map((v, i) => {
                                const isActive = isMenuItemActive(v, location.pathname)
                                return (
                                    <div
                                        key={`${group.key}-${i}`}
                                        className={`menu-item ${isActive ? 'active' : ''}`}
                                    >
                                        <a
                                            style={{ display: 'flex' }}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                history.push(v.route)
                                                onClose()
                                            }}
                                        >
                                            <div className={`menu-icon-box ${isActive ? 'active-icon-box' : ''}`}>
                                                {v.icon && <span className='menu-icon'>{v.icon}</span>}
                                            </div>
                                            <span className={`menu-title`}>{v.title}</span>
                                        </a>
                                    </div>
                                )
                            })}
                        </div>
                    ))}
                </nav >
                <div className='header-icon' role='button' aria-label='User'>
                    {user ? (
                        <span className="header-signout" onClick={handleLogoutButton}>
                            <TbLogout2 className="logout-icon" size={20} />
                            <span className="logout-text">{translations[language]?.logout}</span>
                        </span>
                    ) : (
                        <span
                            className='header-signin'
                            onClick={() => {
                                history.push(allPaths?.LOGIN);
                            }}
                        >
                            <FaUserAlt style={{ marginRight: '8px' }} />
                            {translations[language]?.signIn}
                        </span>
                    )}
                </div>
            </div >
        </>
    )
}

export default MobileMenu
